import React, { useState, useEffect, useRef,useContext } from 'react';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import DynamicIcon from '../../components/dynamicicon';
import JisButton from '../../components/controls/jisButton';
import '../../styles/receipt.css';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisDialogForm from '../../components/formdialog';
import PdfViewer from '../../components/controls/pdfviewer';

export default function PaymentConfirm() {
    const [feeid, setFeeid] = useState(null);
    const [pay, setPay]=useState(null);
     const { fid } = useParams();

     const {refid} = useParams();

     const [err, setErr] = useState('')
    const [loading, setLoading] =useState(false);
    const navigate = useNavigate();
    const {  activePage, token, profile} = useContext(ShareContext);
    const [isPreview, setIsPreview] = useState(false);
    const [previewUrl, setPreviewUrl] =  useState(false);
    const [activefeeid, setActivefeeid] = useState(0);
    const [isUpload, setIsUpload] = useState(false);

    useEffect(() => {
            var _fid= localStorage.getItem("activefeeid")   ;
                if(_fid==null){
                    //redirect another page
                    if(fid){ //coming from param
                        setFeeid(fid);
                       setActivefeeid(fid); 
                    }
                }else{
                  setActivefeeid(_fid);
                    if(fid){ //coming from param
                        setFeeid(fid);
                    }else{
                        setFeeid(_fid);
                    }
                    
                }
              }, []);

      useEffect(() => {
                if(feeid!=null){
                    VerifyPay()
                }
              }, [feeid]);
    
      const VerifyPay=async()=>{
               
              
                  setLoading(true);
                  
                  try {
                  
                    const resp = await fetch(`${Constants.apiUrl}/payment/payment-verify-both/${feeid}`, {
                      method: 'POST',
                      
                      headers: {
                        'Content-Type': 'application/json, text/plain',
                        'Authorization': `Bearer ${token}`,
                      },
                    });
                    
                    const data = await resp.json();
                    setLoading(false);
                    console.log(data);
                    if (data.code === 0) {
                        //setGazettes(data.gazettes);
                        setPay(data.payreceipt);
                        setIsUpload(data.isDocRequired);
                    }else {   
                      setErr("We cannot confirm the payment");
                    }
                  } catch (error) {
                    setLoading(false);
                    console.error(error);
                   // setErr(Constants.serverErr);
                   // onMove();
                  }
          
                 }  
      
    const onRevenueReceipt=()=>{
      //  window.open(pay?.receipt, "_blank");
         setIsPreview(true);
                const finalpath= pay?.receipt;
                setPreviewUrl(finalpath )
             
                console.log(finalpath);

    }

    const onJudiciary=()=>{
      //navigate(`/receipt/${activefeeid}`)
      setIsPreview(true);
      setPreviewUrl(`${Constants.baseurl}/receipt/${activefeeid}`)
    }

    const onUpload=()=>{
        navigate(`/document-upload/${activefeeid}`)
    }
  return (
    <div>
      
      <div class="receipt-section">
        <div class="icons">
       <DynamicIcon iname="done" size={60} />
        </div>
       {err!="" && <div className='error'>{err}</div>} 
        <h3>Payment Successful</h3>
        <div className="payment-details">
      {pay?.payerId && <div className="row"><strong>Payer ID:</strong><span>{pay?.payerId}</span></div>} 
    <div className="row"><strong>Payer Name:</strong><span>{pay?.payerName}</span></div>
   {pay?.paymentTrans && <div className="row"><strong>Transaction Number:</strong><span>{pay?.paymentTrans}</span></div>} 
    <div className="row"><strong>Date and Time of Transaction:</strong><span>{pay?.paymentDate}</span></div>
    {pay?.agencyName && <div className="row"><strong>Receiving HOA Name:</strong><span>{pay?.agencyName}</span></div>}
    <div className="row"><strong>Payment Details:</strong><span>Success</span></div>
 
    <div className="row"><strong>Bill Reference Number:</strong><span>{pay?.reference}</span></div>
   {/*  <div className="row"><strong>Address:</strong><span>20B, Adeola Estate, Ogba, Lagos</span></div> */}
    <div className="row"><strong>Amount:</strong><span>₦ {Constants.formatCurrency(pay?.amountPaid)}</span></div>
   {pay?.agencyCode && <div className="row"><strong>Agency:</strong><span>{pay?.agencyCode}</span></div>} 
   {pay?.revenueCode && <div className="row"><strong>Revenue Code:</strong><span>{pay?.revenueCode}</span></div>} 
  </div>
  <div class="receipt-buttons">
  <JisButton onClick={onJudiciary}>Judiciary Receipt</JisButton>
 {pay?.receipt!="" && <JisButton onClick={onRevenueReceipt}>Revenue Receipt</JisButton>} 
 {isUpload && <JisButton onClick={onUpload}>Upload Document</JisButton>} 
</div>
    </div>
    <BackLoader open={loading} />
    {isPreview && <JisDialogForm title="Receipt" onClose={() =>setIsPreview(false)}>
          <div>
         
            <div className="body" style={{height:'90vh'}}> <PdfViewer   pdfUrl={previewUrl}/>
                               
                                </div>
          </div>
</JisDialogForm>}

    </div>
  );
}

